import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../Note/Notetab';

import { useGetNotesBySourceQuery } from 'store/services/noteApi';

import { useShipmentLoadingDetailContext } from "contexts/ShipmentLoadingDetailContext";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import LoadingShipmentList from "./LoadingShipmentList";

const ShipmentLoadingDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'note';

  const { shipmentLoadingDetail } = useShipmentLoadingDetailContext();

  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    { source: 'ShipmentLoading', sourceRef: shipmentLoadingDetail?._id, }, { skip: !shipmentLoadingDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'ShipmentLoading', sourceRef: shipmentLoadingDetail?._id, }, { skip: !shipmentLoadingDetail?._id }
  );

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
    { label: "Shipment", value: "shipment", badgeCount: shipmentLoadingDetail?.shipmentId.length },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {shipmentLoadingDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="ShipmentLoading" sourceRef={shipmentLoadingDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="ShipmentLoading" sourceRef={shipmentLoadingDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
            <LoadingShipmentList/>
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default ShipmentLoadingDetailTab;